import React from "react";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";

import es from 'date-fns/locale/es';

import "react-datepicker/dist/react-datepicker.css";

registerLocale('es', es);


export default class Datepicker extends React.Component {
    
    state = {
        paralelo: this.props.paralelo, date: (this.props.value ? new Date(this.props.value) : null) ,
    };

  handleChange = date => {
    console.log(" date = " + JSON.stringify(date));
    
    this.setState(
      { date },
      (() => { this.props.onChange(date.toISOString().slice(0, -2), this.props.paralelo) })
    );

    console.log("paralelo = " + JSON.stringify(this.state.paralelo));
    this.props.onChange(date.toISOString().slice(0, -2), this.state.paralelo)
  };

    render() {
        
        return (
            <div className="input-group">
                <DatePicker
                    className="form-control"
                    selected={(this.state.date ?? this.props.value ? new Date(this.props.value) : null)}
                    onChange={date => this.handleChange(date)}
                    name={this.props.name}
                    id={this.props.id}
                    dateFormat={this.props.dateFormat}
                    placeholderText={this.props.placeholder}
                    disabled={(this.props.disabled)}
                    locale="es"
                />
            </div>
        )

    }
}